import * as actionTypes from '../constants/actionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

/**
* function for get user
* @param {*} data User id 
* @description get user by id
* @param {function} getUser getUser function
*/
export const getEmailTemplates = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_EMAIL_TEMPLATE_REQUEST })
        const { data } = await api.getAllEmailTemplates()
        dispatch({ type: actionTypes.GET_EMAIL_TEMPLATE_SUCCESS, payload: data })
        // toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.GET_EMAIL_TEMPLATE_FAIL, payload: err.response.data.message })
    }
}

export const createEmailTemplate = (template, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.CREATE_EMAIL_TEMPLATE_REQUEST })
        const { data } = await api.createAndUpdateEmailTemplate(template)
        toast.success(data.message);
        dispatch({ type: actionTypes.CREATE_EMAIL_TEMPLATE_SUCCESS, payload: data })
        history.push("/admin/email-management")
    } catch (err) {
        toast.error(err?.response?.data?.message);
        dispatch({ type: actionTypes.CREATE_EMAIL_TEMPLATE_FAIL, payload: err?.response?.data?.message })
    }
}

export const getEmailTemplateByType = (type) => {
    return api.getEmailTemplateByType(type)
        .catch((error) => toast.error(error.response.data.message))
}

export const updateEmailTemplate = (template, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_REQUEST })
        const { data } = await api.createAndUpdateEmailTemplate(template)
        dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_SUCCESS, payload: data })
        toast.success(data.message);
        history.push("/admin/email-management")
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_FAIL, payload: err.response.data.message })
    }
}

export const destryoTemplate = (templateId) => async dispatch => {
    try {
        dispatch({ type: actionTypes.DELETE_EMAIL_TEMPLATE_REQUEST })
        const { data } = await api.deleteEmailTemplate(templateId)
        dispatch({ type: actionTypes.DELETE_EMAIL_TEMPLATE_SUCCESS, payload: templateId })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.DELETE_EMAIL_TEMPLATE_FAIL, payload: err.response.data.message })
    }
}

export const updateEmailTemplateStatus = templateStatus => async dispatch =>{
    try {
        dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_REQUEST })
        const { data } = await api.updateEmailTemplateStatus(templateStatus)
        dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_SUCCESS, payload: data })
        toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_FAIL, payload: err.response.data.message })
    }
}